import { Project, ProjectStatus } from '../../types/domainTypes';
import Faker from 'faker';
import { Division } from 'types/domainTypes';

function GenerateProjects() {
  const projects: Project[] = [];

  for (let i = 0; i < 120; i++) {
    const project: Project = {
      id: `${i}`,
      name: `${Faker.company.companyName()}-${i}`,
      engineer: `${Faker.name.findName()}`,
      client: 'Client',
      createdBy: `${Faker.name.findName()}`,
      createdByName: `${Faker.name.findName()}`,
      createdOn: Faker.date.recent(100).toISOString(),
      description: 'Description Text',
      division: Division.Kingspan,
      modifiedBy: `${Faker.name.findName()}`,
      modifiedByName: `${Faker.name.findName()}`,
      modifiedOn: Faker.date.recent(100).toISOString(),
      reference: 'Reference Text',
      notes: 'Notes Text',
      status: ProjectStatus.InProgress,
      standard: {
        country: 'Denmark',
        reference: 'EN 14509',
        annexe: 'TestAnnexe',
        constructionClass: 'TestCC',
        paramsAndCoefficients: 'Ref. EN 14509, Tab E.6',
        loadFactors: 'Ref. EN 14509, Tab E.8',
        supportWidth: {
          end: 40,
          intermediate: 40,
        },
        deflectionLimitRoof: {
          name: 'Standard EN 14509 - Roof',
          pressureLoad: 200,
          suctionLoad: 200,
          cantileverLoad: 50,
          pressureLoadWithCreep: 100,
          cantileverLoadWithCreep: 50,
          customized: false,
        },
        deflectionLimitWall: {
          name: 'Standard EN 14509 - Wall',
          pressureLoad: 100,
          suctionLoad: 100,
          cantileverLoad: 50,
          customized: true,
        },
        createdBy: 'Mock User',
        createdByName: 'Mock User',
        createdOn: '2021-12-22T13:54:30.9188358+00:00',
        modifiedBy: 'Different User',
        modifiedByName: 'Different User',
        modifiedOn: '2022-01-04T10:27:49.8246284+00:00',
      },
      calculations: [],
    };

    projects.push(project);
  }

  return projects;
}

export const mockProjects: Project[] = GenerateProjects();
